<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (crudLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!crudLoading) {
<div class="form-horizontal">
    <div>
      <div class="form-group col-xs-2 col-md-2">
        <label for="taxYear" class="control-label align-left">Tax Year</label>
        <span class="center-year"><strong>{{taxYear}}</strong></span>
      </div>

      <div class="form-group col-xs-1 col-md-2">
        <label for="percentage" class="control-label align-left">Percentage</label>
        <input type="text" 
               id="percentage" 
               class="form-control" 
               [(ngModel)]="percentage"
               (keypress)="onKeyPress($event)"
               (keyup)="onKeyUp($event)"
               min="1" 
               max="100" 
               step="0.01" />
      </div>
    </div>
  </div>
}
</div>

<!-- Footer for modal with standardized buttons -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"  
          type="button"  
          (click)="reset()">Reset</button>
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>

<!--
ORIGINAL ANGULARJS EDIT COMPONENT STRUCTURE WAS MIGRATED TO ANGULAR 12
Original file: ui/app/components/ftc/settings/system-settings-ftc/rd_percentage/rd_sales_adj_percentage_edit.html
Migration preserves all functionality while updating to Angular 12 standards for EDIT mode
-->
